export enum ImageSize {
    Original = 'original',
    Size150x150 = '150x150',
    Size200x200 = '200x200',
    Size190x190 = '190x190',
}
